import { AxiosError } from 'axios';

/**
 * Utility function to handle API errors and throw standardized error messages
 * @param error - The error object caught in the catch block
 * @param customMessage - Custom fallback message to display if no specific error message is available
 * @throws Error with either the API error message or the custom fallback message
 */
export const throwApiError = (error: unknown, customMessage: string): never => {
  console.error('API Error:', error);
  if (error instanceof AxiosError && error?.response?.data?.message) {
    throw new Error(error.response.data.message);
  }
  throw new Error(customMessage);
};
